var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalInfoInstructorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.5C7.45435 8.5 6.69129 8.18393 6.12868 7.62132C5.56607 7.05871 5.25 6.29565 5.25 5.5C5.25 4.70435 5.56607 3.94129 6.12868 3.37868C6.69129 2.81607 7.45435 2.5 8.25 2.5C9.04565 2.5 9.80871 2.81607 10.3713 3.37868C10.9339 3.94129 11.25 4.70435 11.25 5.5C11.25 6.29565 10.9339 7.05871 10.3713 7.62132C9.80871 8.18393 9.04565 8.5 8.25 8.5ZM7.90078 10.9188L7.46484 10.1922C7.31484 9.94141 7.49531 9.625 7.78594 9.625H8.25H8.71172C9.00234 9.625 9.18281 9.94375 9.03281 10.1922L8.59688 10.9188L9.37969 13.8227L10.2234 10.3797C10.2703 10.1898 10.4531 10.0656 10.643 10.1148C12.2859 10.5273 13.5 12.0133 13.5 13.7805C13.5 14.1789 13.1766 14.5 12.7805 14.5H9.69141C9.64219 14.5 9.59766 14.4906 9.55547 14.4742L9.5625 14.5H6.9375L6.94453 14.4742C6.90234 14.4906 6.85547 14.5 6.80859 14.5H3.71953C3.32344 14.5 3 14.1766 3 13.7805C3 12.0109 4.21641 10.525 5.85703 10.1148C6.04688 10.068 6.22969 10.1922 6.27656 10.3797L7.12031 13.8227L7.90312 10.9188H7.90078Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfoInstructorIcon);
export default __webpack_public_path__ + "static/media/AdditionalInfoInstructorIcon.a39e6ac4f2249470870d31c86de2dcc0.svg";
export { ForwardRef as ReactComponent };